import { FLAG_SPACES } from '@app/feature-flags/flags';
import { useFlags } from '@app/hooks/use-flags';
import {
  selectOrganizationName,
  selectOrganizationStatus,
} from '@app/routes/organization/selectors';
import { useAppSelector } from '@app/store';
import { FullscreenModal } from '@hopin-team/component-fullscreen-modal';
import { SidePanelItem } from '@hopin-team/component-fullscreen-modal/dist/partials/side-panel';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ContentContainer = styled.div`
  margin: 0px auto;
  height: 100%;
`;

export const ManageOrganizationModal: React.FC = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const flags = useFlags();

  const organizationName = useAppSelector(selectOrganizationName);
  const status = useAppSelector(selectOrganizationStatus);
  const isSpacesEnabled = Boolean(flags?.[FLAG_SPACES]);

  const organizationTitle =
    status === 'processing'
      ? ''
      : organizationName
      ? organizationName
      : t('manageOrganizationModal.title');

  const teamPath = useMemo(() => {
    return location.pathname.includes('team/pending-invites')
      ? `team/pending-invites`
      : `team/active-members`;
  }, [location.pathname]);

  const spacesSidePanelItem: SidePanelItem = {
    name: t('manageOrganizationModal.sidebar.tabSpaces'),
    iconId: 'folder',
    path: `spaces`,
  };

  const sidePanelItems: SidePanelItem[] = [
    {
      name: t('manageOrganizationModal.sidebar.tabProfile'),
      iconId: 'office',
      path: ``,
    },
    {
      name: t('manageOrganizationModal.sidebar.tabBilling'),
      iconId: 'billing',
      path: `billing`,
    },
    ...(isSpacesEnabled ? [spacesSidePanelItem] : []),
    {
      name: t('manageOrganizationModal.sidebar.tabTeam'),
      iconId: 'team',
      path: teamPath,
    },
  ];

  return (
    <FullscreenModal
      sidePanelItems={sidePanelItems}
      title={organizationTitle}
      backButton={{
        onClick: () => {
          navigate('../');
        },
        isOutlined: true,
        isRound: true,
        size: 'small',
        title: t('manageOrganizationModal.close'),
      }}
      label={t('manageOrganizationModal.title')}
      isDismissible={false}
    >
      <ContentContainer>{children}</ContentContainer>
    </FullscreenModal>
  );
};
